// Theme variables injected by gulp
var THEME_NAME;

THEME_NAME = 'bogen';

angular.module('app.directives', []).directive('onErrorSrc', function() {
  return {
    link: function(scope, element, attrs) {
      return element.bind('error', function() {
        if (attrs.src !== attrs.onErrorSrc) {
          attrs.$set('src', attrs.onErrorSrc);
          return element.addClass('img-error');
        }
      });
    }
  };
}).directive('scrollPage', function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      return element.on('click', function(e) {
        var offset, scrollPage;
        e.preventDefault();
        offset = element.hasClass('nav-link-page') ? -50 : 0;
        scrollPage = new SmoothScroll();
        return scrollPage.animateScroll(document.querySelector($(this).attr('href')), 0, {
          updateURL: false,
          header: '.header',
          offset: offset,
          speed: 200,
          speedAsDuration: true
        });
      });
    }
  };
}).directive("compareTo", function() {
  return {
    require: "ngModel",
    scope: {
      confirmPassword: "=compareTo"
    },
    link: function(scope, element, attributes, modelVal) {
      modelVal.$validators.compareTo = function(val) {
        if (!val) {
          return true;
        }
        return val === scope.confirmPassword;
      };
      return scope.$watch("confirmPassword", function() {
        return modelVal.$validate();
      });
    }
  };
}).directive('exhibitorLogo', function() {
  return {
    restrict: 'A',
    replace: true,
    scope: {
      data: '=exhibitorLogo'
    },
    compile: function(element, attrs) {
      return function(self, element, attrs) {
        var alt, exhibitor, imageUrl, logo;
        if (!self.data) {
          element.html('');
          return;
        }
        logo = self.data.logo || null;
        exhibitor = self.data.exhibitor || null;
        alt = (exhibitor != null ? exhibitor.company : void 0) || (logo != null ? logo.name : void 0) || '';
        if (!logo || logo === '') {
          element.html('');
          return;
        }
        // Build image proxy URL with parameters
        imageUrl = '/image-proxy/' + logo.file + '?quality=80&format=webp&width=100&height=100&mode=contain';
        // If logo exists and exhibitor.id exists, return a->img
        if (logo && exhibitor) {
          return element.html('<a href="/aussteller/' + exhibitor + '" class="logo logo-md-2"><img src="' + imageUrl + '" alt="' + alt + '"></a>');
        }
        // If logo exists but no exhibitor.id, return div->img
        if (logo) {
          return element.html('<div class="logo logo-md-2 ' + exhibitor + '"><img src="' + imageUrl + '" alt="' + alt + '"></div>');
        }
        // Fallback - should not reach here
        return element.html('');
      };
    }
  };
});
